import { alpha } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { tableRowClasses } from "@mui/material/TableRow";
export function table(theme) {
    return {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    position: "relative",
                    borderRadius: 0,
                    backgroundColor: "transparent",
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                    borderWidth: 0,
                    backgroundColor: "transparent",
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.background.neutral,
                    borderRadius: "0px",
                    overflow: "hidden",
                    "& .MuiTableRow-root": {
                        backgroundColor: theme.palette.background.neutral,
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    cursor: "pointer",
                    backgroundColor: "transparent !important",
                    // Remove alternating row colors
                    "&:nth-of-type(even)": {
                        backgroundColor: "transparent !important",
                    },
                    "&:nth-of-type(odd)": {
                        backgroundColor: "transparent !important",
                    },
                    // Selected row style matching DataGrid
                    [`&.${tableRowClasses.selected}`]: {
                        backgroundColor: alpha(theme.palette.primary.main, 0.2),
                    },
                    "&:hover": {
                        backgroundColor: alpha(theme.palette.primary.dark, 0.04),
                    },
                    // Header row styling
                    "&:has(th)": {
                        backgroundColor: theme.palette.background.neutral,
                    },
                    // Remove border from last row
                    "&:last-of-type": {
                        [`& .${tableCellClasses.root}`]: {
                            borderColor: "transparent",
                        },
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    border: "none !important",
                    display: "table-cell",
                    alignItems: "center",
                    height: "auto",
                    minHeight: "56px",
                    fontFamily: theme.typography.fontFamily,
                    fontSize: theme.typography.body2.fontSize,
                    fontWeight: theme.typography.body2.fontWeight,
                    color: theme.palette.text.primary,
                    padding: theme.spacing(2),
                    backgroundColor: "transparent !important",
                    "&:focus": {
                        outline: "none !important",
                    },
                    "&:focus-within": {
                        outline: "none !important",
                    },
                    // Ensure Typography components inherit styles properly
                    "& .MuiTypography-root": {
                        fontFamily: "inherit",
                        fontSize: "inherit",
                        color: "inherit",
                    },
                },
                head: {
                    fontSize: "14px !important",
                    fontWeight: "600 !important",
                    color: theme.palette.text.secondary,
                    backgroundColor: theme.palette.background.neutral,
                    border: "none !important",
                    overflow: "visible !important",
                    height: "auto",
                    minHeight: "52px",
                },
                stickyHeader: {
                    backgroundColor: theme.palette.background.neutral,
                    backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
                    border: "none !important",
                },
                paddingCheckbox: {
                    paddingLeft: theme.spacing(1),
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    width: "100%",
                    borderTop: 0,
                    background: "transparent",
                },
                toolbar: {
                    height: "40px",
                    minHeight: 53,
                },
                actions: {
                    marginRight: 8,
                },
                select: {
                    paddingLeft: 8,
                    "&:focus": {
                        borderRadius: theme.shape.borderRadius,
                    },
                },
                selectIcon: {
                    right: 4,
                    width: 16,
                    height: 16,
                    top: "calc(50% - 8px)",
                    color: "rgba(69, 79, 91, 1)",
                },
            },
        },
    };
}
